import { Slider } from '@mui/material';

type NavigationSliderProps = {
  disabled?: boolean;
  sliderValue: number;
  handleSliderValueChange: (event: Event, newValue: number | number[]) => void;
  step: number;
  marks: any[];
};

export const NavigationSlider = ({
  disabled,
  sliderValue,
  handleSliderValueChange,
  step,
  marks
}: NavigationSliderProps) => {
  return (
    <Slider
      disabled={!!disabled}
      defaultValue={0}
      max={marks[marks.length - 1].value}
      value={sliderValue}
      onChange={handleSliderValueChange}
      step={step}
      marks={marks}
      sx={{
        display: 'flex',
        color: 'rgba(255, 255, 255, 0.7)', // primary color of the track
        height: 10,
        padding: '0 !important',
        minWidth: { lg: '465px' },
        maxWidth: '680px',
        borderRadius: '0px 0px 12px 12px',
        backdropFilter: 'blur(7.5px)',
        ':hover': {
          padding: '0 !important'
        },
        ':focus': {
          padding: '0 !important'
        },
        ':active': {
          padding: '0 !important'
        },
        '& .MuiSlider-thumb': {
          height: 24,
          width: 24,
          backgroundColor: '#fff',
          border: '2px solid currentColor',
          '&:focus, &:hover, &.Mui-active': {
            boxShadow: 'inherit'
          },
          '&:before': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.4)'
          }
        },

        '& .MuiSlider-rail': {
          color: 'rgba(255, 255, 255, 0.5)'
        },
        '& .MuiSlider-mark': {
          display: 'none'
        }
      }}
    />
  );
};
